import React from 'react';

import websitePage from 'hoc/websitePage/websitePage';
import OpenDataPage from 'components/OpenDataPage/OpenDataPage';

import SectionExchangeRate from './patterns/SectionExchangeRate/SectionExchangeRate';

function ExchangeRate() {
  return (
    <OpenDataPage>
      <SectionExchangeRate />
    </OpenDataPage>
  );
}

export default websitePage({
  routeKey: 'EXCHANGE_RATE',
})(ExchangeRate);
